export default "__VITE_ASSET__DSS5$bN4__"